/**
 * Class recipes mirroring the Profile section (MUI): `PurpleButton` / the outlined "Back" button,
 * and its flat 16px text scale (`fontStyles.h3` title, 16/700 sub-header, 16px body, #8C8C8C hints).
 */
// Profile body text is MUI <Typography>, which renders in MUI's default stack (the theme sets no
// `typography`), not the Founders Grotesk that `body` sets; the title and buttons use fontStyles.*.
const font = 'font-[Roboto,Helvetica,Arial,sans-serif]';

export const ui = {
  title: 'text-3xl text-[#222222]', // 32px/40px bold via tailwind.config fontSize['3xl']
  subhead: `${font} text-base font-bold text-[#222222]`,
  body: `${font} text-base text-[#333333]`,
  muted: `${font} text-base text-[#8C8C8C]`,
  link: `${font} bg-transparent p-0 text-base text-[#8C8C8C] underline underline-offset-2`,
  card: 'mt-4 box-border rounded-3xl border border-[#E9E9E9] px-6 pt-5 pb-4', // Profile SectionCard
  btnPrimary:
    'h-12 whitespace-normal rounded bg-[#7801ef] px-[26px] text-xl font-normal text-white hover:bg-[#5800af] disabled:bg-[rgba(88,0,175,0.5)] disabled:opacity-100',
  btnSecondary:
    'h-12 rounded border border-[#E9E9E9] bg-transparent px-[22px] text-xl font-normal text-[#333333] hover:bg-gray-50',
};
